/** @format */
import { css } from 'styled-components';

import { theme } from '@toucan/client/global/theme';

const baseStyles = () => {
    /* eslint-disable @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */
    return css`
        list-style: none;
        padding: 0;
        margin: 0;
        display: flex;
        flex-direction: column;
        gap: var(--layout-spacing-8);

        li {
            min-height: 2.6rem;
        }

        .attribute-label {
            ${theme.typography.body_small};
        }

        .attribute-value {
            ${theme.typography.body_small_highlight}
        }
    `;
    /* eslint-enable @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */
};

export const styles = () => css`
    ${baseStyles()}
`;
